/* istanbul ignore file */

import { KHFileInfo } from './kh-file-info';

export class KhFile {
    constructor(
        public id?: string,
        public fileId?: string,
        public file?: KHFileInfo,
        public containerType?: string
    ) { }
}
